"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valbrenta": {
    "53a05c5b": [{
      "hkey": "c0f61f3c",
      "slug": "fastro-primolano",
      "name": "Fastro-Primolano",
      "primary": true,
      "skipSearch": false
    }],
    "fastro": [{
      "hkey": "c0f61f3c",
      "slug": "fastro-primolano",
      "name": "Fastro-Primolano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f87fc707": [{
      "hkey": "c0f61f3c",
      "slug": "fastro-primolano",
      "name": "Fastro-Primolano",
      "primary": true,
      "skipSearch": false
    }],
    "primolano": [{
      "hkey": "c0f61f3c",
      "slug": "fastro-primolano",
      "name": "Fastro-Primolano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "valbrenta"
    }],
    "3167d074": [{
      "hkey": "369100a4",
      "slug": "san-nazario-merlo",
      "name": "San Nazario-Merlo",
      "primary": true,
      "skipSearch": false
    }],
    "san-nazario": [{
      "hkey": "369100a4",
      "slug": "san-nazario-merlo",
      "name": "San Nazario-Merlo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;